<template>
  <header>
    <nav>
      <ul class="nav-left">
        <!-- Duda on the left -->
        <li class="duda">DUDA</li>
      </ul>
      <ul class="nav-right">
        <!-- Other navigation links -->
        <li><router-link to="/">Start</router-link></li>
        <li><router-link to="/services">Dienstleistungen</router-link></li>
        <li><router-link to="/about">Über Mich</router-link></li>
        <li><router-link to="/contact">Kontakt</router-link></li>
      </ul>
    </nav>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
};
</script>

<style scoped>
header {
  /* position: sticky;
  top: 0; */
  z-index: 1000; /* Ensures it stays above other content */
  padding: 1.3rem;
  /* margin: 0 5%; */
  background-color: #0000008a;
}

nav {
  display: flex;
  justify-content: space-between; /* Space between left and right navigation sections */
  align-items: center; /* Vertically center the items */
  
}

.nav-left,
.nav-right {
  display: flex;
  align-items: center; /* Vertically center the items */
}

.nav-left {
  justify-content: flex-start; /* Align "DUDA" to the left */
}

.nav-right {
  justify-content: center; /* Center the other nav items */
}

nav ul {
  display: flex;
  list-style: none;
  margin: 0;
  padding: 0;
}

nav ul li {
  margin: 0 2rem;
}

nav ul li a {
  color: white;
  text-decoration: none;
  font-size: 1.1rem;
}

nav ul li a:hover {
  text-decoration: underline;
}

/* Additional styling for "DUDA" */
nav ul li.duda {
  color: white;
  font-weight: bold; /* Optional: make "DUDA" stand out */
  font-size: 1.4rem; /* Optional: adjust font size for "DUDA" */
}
</style>
